export const ENDPOINTS = {
  // Chat
  CHAT: '/chat',

  // Conversations
  CONVERSATIONS: '/api/conversations',
  CONVERSATION_DETAIL: (id: string) => `/api/conversations/${id}`,
  CONVERSATION_MESSAGES: (id: string) => `/api/conversations/${id}/messages`,

  // Auth
  AUTH_GITHUB: '/api/auth/github/token',

  // Users (provisioned cardholders / app access)
  USERS: '/api/users',
  USER_DETAIL: (id: string) => `/api/users/${id}`,

  // Health
  HEALTH: '/health',
  HEALTH_DETAILED: '/api/health',
} as const;
